import {createAction, props} from '@ngrx/store';
import { DripLessonConfig } from "../models/drip-lesson-config.model";



export const dripLessonsConfigLoaded = createAction(
  '[Drip Lessons Activity Effects] Drip Lessons Config Loaded',
  props<{courseId:string, events: DripLessonConfig[]}>()
);
